import { render } from "./AddMemberToGroup.vue?vue&type=template&id=02c4b352&scoped=true"
import script from "./AddMemberToGroup.vue?vue&type=script&lang=js"
export * from "./AddMemberToGroup.vue?vue&type=script&lang=js"

import "./AddMemberToGroup.vue?vue&type=style&index=0&id=02c4b352&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c4b352"]])

export default __exports__